module.exports = __webpack_public_path__ + "static/media/eco-friendly-car.aaa046f6.jpg";